import { _ as _castPath } from './_castPath.mjs';
import { l as last_1 } from './last.mjs';
import { _ as _parent } from './_parent.mjs';
import { _ as _toKey } from './_toKey.mjs';

var castPath = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset;

export { _baseUnset as _ };
